/* eslint-disable react/prop-types */
import React from 'react';
import { Button, Popconfirm } from 'antd';
import { useNavigate } from 'react-router-dom';

function SettingsToolbar({ screenModified, loading }) {
  const navigate = useNavigate();

  return (
    <div className="form-toolbar">
      {screenModified && (
        <Popconfirm
          title="Deseja mesmo voltar?"
          onConfirm={() => navigate(-1)}
          okText="Sim"
          cancelText="Não"
        >
          <Button>Voltar</Button>
        </Popconfirm>
      )}
      {!screenModified && <Button onClick={() => navigate(-1)}>Voltar</Button>}
      <Button loading={loading} block type="primary" htmlType="submit">
        Salvar
      </Button>
    </div>
  );
}

export default SettingsToolbar;
